import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit'
import messageReducer from './reducers/messages'
import userReducer from './reducers/users'
import modalReducer from './reducers/modal'
import toastReducer from './reducers/toasts'
import headerModalSlice from './reducers/header'

// keeps inferred types when passed to createStore. Using Partial<ConfigureStoreOptions> doesn't infer properly
interface CreateStoreOptions {
  preloadedState?: ConfigureStoreOptions['preloadedState']
}

export const createStore = (options?: CreateStoreOptions) => {
  return configureStore(
    {
      reducer: {
        messages: messageReducer,
        users: userReducer,
        modal: modalReducer,
        header: headerModalSlice,
        toasts: toastReducer
      },
      ...options
    }
  )
}

const store = createStore()

export type ReduxStore = typeof store
export type RootState = ReturnType<typeof store.getState>

export default store
